export const handleLangFormat = (lang: string) => {
  switch (lang) {
    case 'EE': return 'et';
    case 'CZ': return 'cs';
    default: return lang.toLowerCase();
  }
}